module.exports = __webpack_public_path__ + "static/media/pleading_face.25898e07.svg";